import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const PROMOTE_PROVIDER = 'PROMOTE_PROVIDER';
export const PROMOTE_PROVIDER_SUCCESS = 'PROMOTE_PROVIDER_SUCCESS';
export const PROMOTE_PROVIDER_FAILURE = 'PROMOTE_PROVIDER_FAILURE';

// Action Creators
export const fetchPromoteProvider = () => ({
  type: PROMOTE_PROVIDER,
});

export const fetchPromoteProviderSuccess = (data) => ({
  type: PROMOTE_PROVIDER_SUCCESS,
  payload: data,
});

export const fetchPromoteProviderFailure = (error) => ({
  type: PROMOTE_PROVIDER_FAILURE,
  payload: error,
});

// Thunk Function
export const promoteProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchPromoteProvider(data, external));
    try {
      const response = await putMethodWithToken(
        url.promoteProviderRequestSuperAdmin + data?.data?.id + '/',
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchPromoteProviderSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchPromoteProviderFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchPromoteProviderFailure(error.message));
    }
  };
};
